import React from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { ErrorBoundary } from './components/ErrorBoundary';
import './styles.css';

const el = document.getElementById('root');
if (!el) throw new Error('Missing #root');

createRoot(el).render(
  <React.StrictMode>
    {/* Backstop only. The boundary that matters is the scoped one around the
        preview — this one exists so a bug elsewhere still explains itself
        instead of leaving a blank page. */}
    <ErrorBoundary label="Undertone">
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
);
